import { FormHorizontal } from '~/components/form/layout';
import { TenantPerformableFormProps } from '~/tenants/common/form';
import ZodFieldInput from '~/components/zod/ZodFieldInput';
import { TenantPerformableConfiguration } from '~/tenants/common/performable';
import { MlmOrderContext } from '../../model/MlmOrder';

export default function MlmVirtualStagingForm(_props: TenantPerformableFormProps<MlmOrderContext>) {
  return (
    <TenantPerformableConfiguration>
      <FormHorizontal name="photos" label="Photos">
        <ZodFieldInput name="photos" type="number" />
      </FormHorizontal>
    </TenantPerformableConfiguration>
  );
}
